import { render, staticRenderFns } from "./JdsRichRadioOption.vue?vue&type=template&id=05e1729f&scoped=true&"
import script from "./JdsRichRadioOption.vue?vue&type=script&lang=ts&"
export * from "./JdsRichRadioOption.vue?vue&type=script&lang=ts&"
import style0 from "./JdsRichRadioOption.vue?vue&type=style&index=0&id=05e1729f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1729f",
  null
  
)

export default component.exports